import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";
import { ProcessoAuditoriasLista } from "../../models/processo_auditorias_lista";
import { IGetAllAuditorProcessoAuditoriasUseCase } from "../../../presentation/useCases/read/get_all_auditor_processo_auditorias_use_case";
import { ProcessoAuditoriasListaFilter } from "../../models/auditor_processo_auditorias_filter";


// GetAllAuditoriasProcessoAuditoriasServicoUseCase


export class GetAllAuditoriasProcessoAuditoriasServicoUseCase
  extends BasePaginatedUseCase<ProcessoAuditoriasLista>
  implements IGetAllAuditorProcessoAuditoriasUseCase {
  constructor(private readonly repository: IAuditorRepository) {
    super();
  }

  async getAllListagemProcessoAuditoria(
    filter: ProcessoAuditoriasListaFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdAuditoria === undefined) throw new Error('Id de auditoria invalido!');

    const response = await this.repository
      .getAllListagemProcessoAuditoria(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
